import CampusEditFormComponent from './campus-edit-form-component';
import CampusEditFormService from './campus-edit-form-service';

/***
 * the sub-page within the Client Edit page that contains a form for editing Campus settings.
 */
const campusEditForm = angular
    .module('FacilityData.ClientEdit.CampusEditForm', [])
    .component('campusEditForm', CampusEditFormComponent)
    .service('CampusEditFormService', CampusEditFormService)
    .config($stateProvider => {
        'ngInject';

        $stateProvider.state('app.client-edit.campus', {
            url: 'campus/:campusId/',
            component: 'campusEditForm',
            resolve: {
                campus: ($stateParams, CommonRequest) => CommonRequest.getCampusDetails($stateParams.campusId),
                serviceList: CampusEditFormService => CampusEditFormService.getServices(),
                countries: (campus, CampusEditFormService) => CampusEditFormService.fetchCountry(campus.country),
            },
        });
    }).name;

export default campusEditForm;



// WEBPACK FOOTER //
// ./app/components/client-edit/campus-edit-form/campus-edit-form.js